import { render, staticRenderFns } from "./NsCurrency.vue?vue&type=template&id=77f7e931&scoped=true&"
import script from "./NsCurrency.vue?vue&type=script&lang=js&"
export * from "./NsCurrency.vue?vue&type=script&lang=js&"
import style0 from "./NsCurrency.vue?vue&type=style&index=0&id=77f7e931&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77f7e931",
  null
  
)

export default component.exports